import { jsx as _jsx } from "react/jsx-runtime";
const LayoutEDS = ({ children }) => {
    return _jsx("div", { className: "content", children: children });
};
export { LayoutEDS as default };
